import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'beautyJson'
})
export class BeautyJsonPipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer){}

  transform(value: any, args?: any): any {

      if(typeof value != 'object' && value != null){
          //daba error cuando se devolvia un objeto pero  como string
          if(value.includes('{')){
              value=JSON.parse(value);
              }else{
              return value;
          }
          }
      let resp = '';
    for(let k in value){
     if(typeof value[k] != 'object'){
         resp+='<li><b>'+k+'</b>'+' : '+value[k]+'</li>';
     }else{
         resp+='<li><b>'+k+'</b></li><ul>';
         for( let subk in value[k]){
             if(typeof value[k][subk] === 'object'){
                 resp+='<ul><li><b>'+subk+'</b></li><ul>';
                 for(let subk2 in value[k][subk]){
                     resp+='<li><b>'+subk2+'</b> :'+JSON.stringify(value[k][subk][subk2])+'</li>'
                 }
                 resp+='</ul>';
                 }else{
                 resp+='<li><b>'+subk+'</b>'+' : '+value[k][subk]+'</li>';
             }
             resp+='</ul>';
         }
         resp+='</ul>';
     }

    }
    return this.sanitize.bypassSecurityTrustHtml(resp)
  }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/beauty-json.pipe.ts